import {
  CugTier,
  GHAAccountType,
  GHAPropertyBrand,
  GHAPropertyClassificationTier,
} from '~/services/ConnectionGoogleService';

export const ACCOUNT_TYPE_ORDER: Array<GHAAccountType> = ['lpp', 'alt', 'lpc', 'le_vacation_rental', 'scoopon'];

export const ACCOUNT_TYPE_LABELS: Record<GHAAccountType, string> = {
  lpp: 'LPP',
  alt: 'ALT',
  scoopon: 'Scoopon',
  lpc: 'LPC',
  le_vacation_rental: 'LE Vacation Rental',
};

export const ACCOUNT_TYPES_BY_BRAND: Record<GHAPropertyBrand, Array<GHAAccountType>> = {
  luxuryescapes: ['lpp', 'alt', 'lpc', 'le_vacation_rental'],
  scoopontravel: ['scoopon'],
};

export const DISTANCE_GROUP_OPTIONS = ['< 0.1km', '0.1-1km', '1-10km', '> 10km', 'null'] as const;

export const DISTANCE_GROUP_LABELS: Record<string, string> = {
  '< 0.1km': '< 0.1km',
  '0.1-1km': '0.1-1km',
  '1-10km': '1-10km',
  '> 10km': '> 10km',
  null: 'No cross-sell data',
};

// CUG tier values; 'no_tier' is the default (untiered).
export const CUG_TIER_VALUES: Record<'NO_TIER' | 'TIER_1' | 'TIER_2' | 'TIER_3' | 'TIER_4', CugTier> = {
  NO_TIER: 'no_tier',
  TIER_1: 'tier_1',
  TIER_2: 'tier_2',
  TIER_3: 'tier_3',
  TIER_4: 'tier_4',
};

export const CUG_TIER_LABELS: Record<CugTier, string> = {
  tier_1: 'Tier 1',
  tier_2: 'Tier 2',
  tier_3: 'Tier 3',
  tier_4: 'Tier 4',
  no_tier: 'No Tier',
};

// Dropdown order: concrete tiers first, "No Tier" last.
export const CUG_TIER_OPTIONS: Array<CugTier> = [
  CUG_TIER_VALUES.TIER_1,
  CUG_TIER_VALUES.TIER_2,
  CUG_TIER_VALUES.TIER_3,
  CUG_TIER_VALUES.TIER_4,
  CUG_TIER_VALUES.NO_TIER,
];

// Pull-with-Hints classification tier. Unrelated to CUG_TIER_* above — that one is `cug_tier`,
// labelled "Property Tier" in this screen. Held per GHA account, so it only has a meaning once
// an Account Type is selected.
export const CLASSIFICATION_TIER_OPTIONS: Array<GHAPropertyClassificationTier> = ['HIGH', 'MEDIUM', 'LOW'];

export const CLASSIFICATION_TIER_LABELS: Record<GHAPropertyClassificationTier, string> = {
  HIGH: 'High',
  MEDIUM: 'Medium',
  LOW: 'Low',
};
